import React from "react";
import "./Website.css";
import Footer from "./footer/Footer.jsx";
import Profile from "./body/profile/Profile.jsx";
import Header from "./header/Header.jsx";
import Title from "./title/Title.jsx";
import Research from "./body/research/research.jsx";
export default class Website extends React.Component {
  render() {
    return (
      <>
        <div class="all">
          <header>
            <Header />
          </header>
          <div id="particles-js">
            <div id="wrapper">
              <Title />
              <Profile />
              <Research />
            </div>
          </div>
        </div>
        <footer>
          <Footer />
        </footer>
        <script src="http://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js"></script>
        <script src="particles.js"></script>
      </>
    );
  }
}
